import { getFeature } from 'Cloud/Application/FeaturesEs6';

/** Пказываем тока b2c за счет того, что есть SharingNew и SharingNewBiz */
export const SHARE_SPACE_CONSUMPTION_WARNING_ENABLED = getFeature('share-space-consumption-warning');

export const SHARE_SPACE_CONSUMPTION_HREF = getFeature('share-space-consumption-href') || 'https://help.mail.ru/cloud_web/folders/public/';
